module.exports = __webpack_public_path__ + "img/upload-file.1db791a2.png";